"use strict";
'kiwi public';

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/getPrototypeOf"));
var _websocket = _interopRequireDefault(require("irc-framework/src/transports/websocket"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;
var MAX_STARTUP_REPLAY_LINES = 2048;
var MAX_STARTUP_REPLAY_BYTES = 1024 * 1024;

/** WebSocket transport adapter for the opt-in gateway protocol. */
var GatewayTransport = /*#__PURE__*/function (_WebsocketTransport) {
  (0, _inherits2.default)(GatewayTransport, _WebsocketTransport);
  var _super = _createSuper(GatewayTransport);
  function GatewayTransport(options) {
    var _this;
    (0, _classCallCheck2.default)(this, GatewayTransport);
    _this = _super.call(this, options);
    // Connection.options is reused by irc-framework reconnects; capture per transport instance.
    _this.gatewayResume = options.gatewayResume;
    _this.disposed = true;
    _this.registrationGate = false;
    _this.registrationReady = false;
    _this.registrationLines = [];
    _this.registrationBytes = 0;
    return _this;
  }
  (0, _createClass2.default)(GatewayTransport, [{
    key: "clearRegistrationGate",
    value: function clearRegistrationGate() {
      this.registrationGate = false;
      this.registrationReady = false;
      this.registrationLines = [];
      this.registrationBytes = 0;
    }
  }, {
    key: "connect",
    value: function connect() {
      var _context;
      var resume = this.gatewayResume;
      this.disposed = false;
      this.gatewaySocketOpened = false;
      var token = null;
      try {
        token = resume.takeToken();
      } catch (err) {
        token = null;
      }
      if (resume.abortStartupAttempt && resume.abortStartupAttempt()) {
        this.disposed = true;
        return;
      }
      if (!TOKEN_RE.test(token || '')) {
        token = null;
      }
      var configuredPath = resume.path;
      this.options.path = token ? (0, _concat.default)(_context = "".concat(configuredPath, "?resume=")).call(_context, token) : "".concat(configuredPath, "?gw=1");
      // The URL is deliberately not emitted to debug output; the credential is one-time.
      this.browserAttemptId = resume.attemptStarted(this);
      try {
        (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "connect", this).call(this);
      } catch (err) {
        resume.transportUnavailable(this, this.browserAttemptId);
        throw err;
      }
      this.disposed = false;
    }
  }, {
    key: "disposeSocket",
    value: function disposeSocket() {
      this.disposed = true;
      this.clearRegistrationGate();
      if (this.socket && !this.connected) {
        var socket = this.socket;
        this.socket = null;
        socket.onopen = null;
        socket.onclose = null;
        socket.onmessage = null;
        socket.onerror = null;
        try {
          socket.close();
        } catch (err) {
          // The socket may already have left CONNECTING/CLOSING.
        }
        return;
      }
      (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "disposeSocket", this).call(this);
    }
  }, {
    key: "abortAttempt",
    value: function abortAttempt(attemptId) {
      if (this.browserAttemptId !== attemptId || this.disposed) {
        return;
      }
      this.disposed = true;
      this.connected = false;
      this.clearRegistrationGate();
      var socket = this.socket;
      this.socket = null;
      if (socket) {
        socket.onopen = null;
        socket.onclose = null;
        socket.onmessage = null;
        socket.onerror = null;
        try {
          socket.close();
        } catch (err) {
          // The socket may already have left CONNECTING/CLOSING.
        }
      }
    }
  }, {
    key: "onSocketFullyConnected",
    value: function onSocketFullyConnected() {
      if (!this.disposed) {
        this.gatewaySocketOpened = true;
        this.gatewayResume.attemptOpened(this, this.browserAttemptId);
        (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "onSocketFullyConnected", this).call(this);
      }
    }
  }, {
    key: "onSocketMessage",
    value: function onSocketMessage(data) {
      var _this2 = this;
      if (this.disposed) {
        return;
      }
      if (typeof data !== 'string') {
        (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "onSocketMessage", this).call(this, data);
        return;
      }
      this.lastMessageAt = Date.now();
      this.incoming_buffer += data + '\n';
      var lines = this.incoming_buffer.split('\n');
      if (lines[lines.length - 1] !== '') {
        this.incoming_buffer = lines.pop();
      } else {
        lines.pop();
        this.incoming_buffer = '';
      }
      lines.forEach(function (wireLine) {
        if (_this2.disposed) {
          return;
        }
        var line = wireLine.replace(/\r$/, '');
        if (_this2.gatewayResume.isStartupResume && _this2.gatewayResume.isStartupResume() && /^\s*(?:@[^ ]+\s+)?(?::\S+\s+)?001\s/i.test(line)) {
          _this2.registrationGate = true;
          _this2.registrationReady = false;
        }
        if (/^\s*(?:@[^ ]+\s+)?(?::\S+\s+)?PONG\s/i.test(line) && _this2.gatewayResume.probePong(line, _this2, _this2.browserAttemptId)) {
          return;
        }
        if (/^\s*(?:@[^ ]+\s+)?(?::\S+\s+)?GW\s+RESUMETOKEN\s/i.test(line)) {
          // Never pass bearer tokens to the framework debug/raw/middleware pipeline.
          _this2.gatewayResume.control(line, _this2, _this2.browserAttemptId);
          return;
        }
        var resumedLine = /^\s*(?:@[^ ]+\s+)?(?::\S+\s+)?GW\s+RESUMED\s+/i.test(line);
        if (resumedLine && _this2.gatewayResume.isStartupResume && _this2.gatewayResume.isStartupResume() && !_this2.registrationGate) {
          _this2.gatewayResume.registrationOrderError(_this2, _this2.browserAttemptId);
          return;
        }
        if (_this2.registrationGate && resumedLine) {
          if (!_this2.registrationReady) {
            _this2.gatewayResume.registrationOrderError(_this2, _this2.browserAttemptId);
            return;
          }
          (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "onSocketMessage", _this2).call(_this2, wireLine);
          var pending = _this2.registrationLines;
          _this2.clearRegistrationGate();
          pending.forEach(function (pendingLine) {
            return (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "onSocketMessage", _this2).call(_this2, pendingLine);
          });
          _this2.gatewayResume.registrationCommitted(_this2, _this2.browserAttemptId);
          return;
        }
        if (_this2.registrationGate) {
          var ping = line.match(/^(?:@[^ ]+\s+)?PING\s+(.+)$/i);
          if (ping) {
            var pingPayload = ping[1].replace(/^:/, '');
            _this2.writeLine("PONG :".concat(pingPayload));
            return;
          }
          // Two bytes per UTF-16 code unit conservatively bounds queued JS string memory.
          _this2.registrationBytes += wireLine.length * 2;
          if (_this2.registrationBytes > MAX_STARTUP_REPLAY_BYTES || _this2.registrationLines.length >= MAX_STARTUP_REPLAY_LINES) {
            _this2.gatewayResume.registrationOverflow(_this2, _this2.browserAttemptId);
            return;
          }
          if (/^\s*(?:@[^ ]+\s+)?(?::\S+\s+)?(?:376|422)\s/i.test(line)) {
            _this2.registrationReady = true;
          }
          _this2.registrationLines.push(wireLine);
          return;
        }
        (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "onSocketMessage", _this2).call(_this2, wireLine);
      });
    }
  }, {
    key: "onSocketClose",
    value: function onSocketClose(event) {
      if (this.disposed) {
        return;
      }
      if (event && event.code === 4001) {
        // Framework checks these synchronously after its socket-close event returns.
        this.gatewayResume.takeover(this, this.browserAttemptId);
      }
      var wasOpened = this.gatewaySocketOpened;
      this.disposed = true;
      this.clearRegistrationGate();
      if (!wasOpened && (!event || event.code !== 4002)) {
        this.gatewayResume.transportUnavailable(this, this.browserAttemptId);
      }
      // Busy (1013) or upstream unreachable (1011): back off before the framework's
      // socket-close handlers schedule the retry.
      if (wasOpened && event && (event.code === 1013 || event.code === 1011) && this.gatewayResume.serverBusy) {
        this.gatewayResume.serverBusy(this, this.browserAttemptId);
      }
      (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "onSocketClose", this).call(this, event);
      if (event && event.code === 4002) {
        this.gatewayResume.invalidResume(this, this.browserAttemptId);
      }
      this.gatewayResume.attemptClosed(this, this.browserAttemptId);
    }
  }, {
    key: "close",
    value: function close() {
      // Framework reconnects use this transport method; normal close semantics remain intact.
      (0, _get2.default)((0, _getPrototypeOf2.default)(GatewayTransport.prototype), "close", this).call(this);
    }
  }]);
  return GatewayTransport;
}(_websocket.default);
exports.default = GatewayTransport;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["GatewayTransport"]
window._kiwi_exports.libs.GatewayTransport = exports.default ? exports.default : exports;
